import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { MeProvider } from "./MeContext";
import { Shell } from "./Shell";
import { AccountsPage } from "@/pages/AccountsPage";
import { AccountPage } from "@/pages/AccountPage";
import { AdminPage } from "@/pages/AdminPage";
import { DocsLibraryPage } from "@/pages/DocsLibraryPage";
import { HomePage } from "@/pages/HomePage";
import { InboxPage } from "@/pages/InboxPage";
import { TodosPage } from "@/pages/TodosPage";
import { CalendarPage } from "@/pages/CalendarPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { LeadsPage } from "@/pages/LeadsPage";
import { PipelinePage } from "@/pages/PipelinePage";
import { SystemsPage } from "@/pages/SystemsPage";
import { TicketsPage } from "@/pages/TicketsPage";
import { QuotesPage } from "@/pages/QuotesPage";
import { PartnersPage } from "@/pages/PartnersPage";
import { PublicQuotePage } from "@/pages/public/PublicQuotePage";
import { PublicSignPage } from "@/pages/public/PublicSignPage";

function Internal() {
  return (
    <MeProvider>
      <Routes>
        <Route element={<Shell />}>
          <Route index element={<HomePage />} />
          <Route path="inbox" element={<InboxPage />} />
          <Route path="inbox/:threadId" element={<InboxPage />} />
          <Route path="todos" element={<TodosPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="leads" element={<LeadsPage />} />
          <Route path="pipeline" element={<PipelinePage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="accounts/:id" element={<AccountPage />} />
          <Route path="accounts/:id/:tab" element={<AccountPage />} />
          <Route path="systems" element={<SystemsPage />} />
          <Route path="tickets" element={<TicketsPage />} />
          <Route path="tickets/:id" element={<TicketsPage />} />
          <Route path="quotes" element={<QuotesPage />} />
          <Route path="quotes/:id" element={<QuotesPage />} />
          <Route path="partners" element={<PartnersPage />} />
          <Route path="partners/:id" element={<PartnersPage />} />
          <Route path="partners/:id/:tab" element={<PartnersPage />} />
          <Route path="docs" element={<DocsLibraryPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </MeProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/p/quote/:token" element={<PublicQuotePage />} />
        <Route path="/p/sign/:token" element={<PublicSignPage />} />
        <Route path="/*" element={<Internal />} />
      </Routes>
    </BrowserRouter>
  );
}
